<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-brand center>Sea Freight Import Details</b-navbar-brand>

          <!-- <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button size="sm" variant="warning" @click="goToMain">New Client</b-button>
            </b-nav-form>
          </b-navbar-nav>-->
        </b-navbar>

        <!-- User Interface controls -->
        <div class="row">
          <div class="col-md-8">
            <b-form-group style="margin: 0; margin-bottom: 10px !important">
              <b-input-group>
                <b-form-input :formatter="capitalizeAll" v-model="filter" @input="debounceSearch"
                  placeholder="Type To Search (Assignment No. / Importer / BL No. / Container No.)" />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <model-list-select @input="viewFFExportFCL('0', '0', '1', '1')" :list="invoiceStatusList"
              v-model="billingFilter" option-value="inv" option-text="int"
              placeholder="Select Status"></model-list-select>
          </div>
          <div class="col-md-2">
            <model-list-select @input="viewFFExportFCL('Normal', '0', '0', '1', '1')" :list="dateStatusList"
              v-model="dateStatusFilter" option-value="inv" option-text="int"
              placeholder="Select Date Filter"></model-list-select>
          </div>
          <div class="mt-0 col-md-12">
            <h5 class="text-muted pull-right">
              <small v-if="isLoading == false">{{ totalRows }} Entries</small>
            </h5>
          </div>
        </div>
        <!-- Main table element -->
        <div class="table-responsive tableMain">
          <b-table show-empty stacked="md" :items="seaImportData" :fields="fields" :per-page="perPage"
            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
            <template slot="ffImportId" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="ffImportSeries" slot-scope="row11">
              <div @click="
                row11.item.is_locked == '1' &&
                  (row11.item.finalBillingCompleted == 1 ||
                    row11.item.locked_counter > 0) &&
                  $sessionsStorage.get('designation') != 'Admin' &&
                  $sessionsStorage.get('nameUser') != 'Bhavneesh'
                  ? ''
                  : viewExportSeaPage(row11.item)
                " class="showMoreData">
                <b :style="row11.item.seenExec == '0' ? 'color:red' : 'color:black'">
                  {{ row11.item.ffImportSeries }}
                  <br />
                </b>

                <span>
                  Raised From : {{ row11.item.EmpLoc }}
                  <br />
                </span>
                <span>
                  Assignment Date : {{ row11.item.loginTime | moment }}
                  <br />
                </span>
                <b-button style="font-size: 0.675rem" class="mt-2" size="sm" @click="
                  row11.item.is_locked == '1' &&
                    (row11.item.finalBillingCompleted == 1 ||
                      row11.item.locked_counter > 0)
                    ? LockUnLock(row11.item, 'locked')
                    : ''
                  " :variant="row11.item.is_locked == '1' &&
                      (row11.item.finalBillingCompleted == 1 ||
                        row11.item.locked_counter > 0)
                      ? 'danger'
                      : 'success'
                    "><b v-if="
                    row11.item.is_locked == '1' &&
                    (row11.item.finalBillingCompleted == 1 ||
                      row11.item.locked_counter > 0)
                  "><i class="fa fa-lock mr-1 lg"></i>LOCKED</b><b v-else><i
                      class="fa fa-unlock mr-1 lg"></i>UN-LOCKED</b></b-button><br />
              </div>
              <Assignment-Summary :title="'Shipment Summary Tracking - '" :fk_all_module_id="row11.item.allModuleId"
                :jb_series="row11.item.ffImportSeries" />
              <!-- <JobWisePaymentsDetails
                  v-if="row11.item.allModuleId"
                  :allModuleId="Number(row11.item.allModuleId)"
                  :JobNo="row11.item.ffImportSeries"
                  /> -->
                   <RejectInvTallyBillSummary
                    v-if="row11.item.allModuleId"
                    :PMC_title="'Invoice Rejection Log Summary Job No - ' + row11.item.ffImportSeries"
                    :PMC_JOBID="row11.item.allModuleId.toString()"
                    :PMC_JOBNO="row11.item.ffImportSeries"
                    :PMC_JOBDATE="''"
                    :PMC_JOBTYPE="''"
                    :PMC_Client="''"
                    :PMC_Sline="''"
                  />
              <ContainerSummary v-if="row11.item.allModuleId"
                :PMC_title="'Container Summary Job No - ' + row11.item.ffImportSeries"
                :PMC_JOBID="row11.item.allModuleId" :PMC_JOBNO="row11.item.ffImportSeries" :PMC_JOBDATE="''"
                :PMC_JOBTYPE="''" :PMC_AgentType="''" :PMC_Client="''" :PMC_Sline="''" />
              <MSDeleteRequest :item="row11.item" :JobNo="row11.item.ffImportSeries" :JobID="row11.item.allModuleId"
                :sessionsStorage="$sessionsStorage" @refreshData="handleRefresh" />
              <BRFCard v-if="row11.item.prbr_id" :BRFDetails="null" :prbr_id="Number(row11.item.prbr_id)" />
              <b
                v-if="row11.item.deleteRequestBy != '' && row11.item.deleteRequestBy != '0' && row11.item.deleteRequestBy != null">Requested
                By : {{ row11.item.deleteRequestBy }}<br /></b>
              <b
                v-if="row11.item.deleteArrovedBy != '' && row11.item.deleteArrovedBy != '0' && row11.item.deleteArrovedBy != null">Arroved
                By : {{ row11.item.deleteArrovedBy }}<br /></b>

            </template>
            <template slot="ContainerNo" slot-scope="row5">
              <div v-if="row5.item.ContainerNo != null">
                <div v-if="row5.item.ContainerNo != null">
                  <span v-for="(item1, index) in row5.item.ContainerNo.split(',')" :key="index">
                    <h6>
                      <b-badge variant="light">{{
                        item1 == "" ? "-------" : item1
                      }}</b-badge>
                    </h6>
                  </span>
                </div>
              </div>
              <div v-else>
                <b-badge variant="light">-------</b-badge>
              </div>
            </template>
            <template slot="containerTypeName" slot-scope="row50">
              <div v-if="row50.item.containerTypeName != null">
                <div v-if="row50.item.containerTypeName != null">
                  <span v-for="(item2, index) in row50.item.containerTypeName.split(',')" :key="index">
                    <h6>
                      <b-badge variant="light">{{
                        item2 == "" ? "-------" : item2
                      }}</b-badge>
                    </h6>
                  </span>
                </div>
              </div>
              <div v-else>
                <b-badge variant="light">-------</b-badge>
              </div>
            </template>
            <template slot="placeOfReceipt" slot-scope="row12">
              <span>
                POR : {{ row12.item.placeOfReceipt }}
                <br />
              </span>
              <span>
                Load Port : {{ row12.item.loadPort }}
                <br />
              </span>
              <span>
                POD : {{ row12.item.portOfDischarge }}
                <br />
              </span>

              <span>
                FPOD : {{ row12.item.finalPlaceDelivery }}
                <br />
              </span>
              <span>
                S-Line : {{ row12.item.shippingLine }}
                <br />
              </span>
              <span>
                BOE NO : {{ row12.item.BOE_NO }}
                <br />
              </span>
              <span>
                BOE Date : {{ row12.item.BOE_Date }}
                <br />
              </span>
            </template>

            <template slot="invoiceStatus" slot-scope="row33">
              <b :style="row33.item.invoiceStatus == '0' ? { color: 'green' } : { color: 'red' }
                ">{{
                  !row33.item.invoiceStatus
                    ? "--"
                    : row33.item.invoiceStatus == "1"
                      ? "In-Progress"
                      : row33.item.invoiceStatus == "0"
                        ? "Sent To Accounts"
                        : "--"
                }}</b>
              <b v-if="row33.item.sentForApproval && row33.item.sentForApproval == '1'">
                <br />
                Sent for Approval
              </b>
              <b v-if="
                row33.item.chnageApprovalStatus &&
                row33.item.chnageApprovalStatus == '1'
              ">
                <br />
                Was Sent for Approval and got Approved
              </b>
              <b v-if="
                row33.item.chnageApprovalStatus &&
                row33.item.chnageApprovalStatus == '2'
              ">
                <br />
                Was Sent for Approval and got Rejected
              </b>
            </template>

            <template slot="portOfDischarge" slot-scope="row55">
              <!-- <b-button
                size="sm"
                @click="goToDoc(row55.item.ffImportId)"
                variant="outline-info"
              >View Documents</b-button> -->

              <b-button size="sm" @click="showDocModal(row55.item)" variant="outline-dark">Summary &
                Documents</b-button>
              <Add-Message :fk_all_module_id="row55.item.allModuleId" :fk_client_id="row55.item.clientId"
                :fk_pod_id="row55.item.PODLocationId" style="list-style-type: none" />
            </template>
          </b-table>
        </div>
        <h5>
          <b-row>
            <b-col md="12" class="my-1">
              <b-pagination limit="5" align="center" v-model="currentPage" :per-page="perPage" :total-rows="totalRows"
                @change="onPageChange($event)"></b-pagination>
              <!-- <b-pagination
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0 pull-right"
            />-->
            </b-col>
          </b-row>
        </h5>
      </b-card-text>
    </b-card>
    <div>
      <b-modal size="xl" class="modal-dialog-doc" no-close-on-esc no-close-on-backdrop ref="doc-modal" hide-footer
        :title="'Assignment Summary & Documents - ' + JOBSERIES">
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal">Close
        </b-button>
      </b-modal>
      <!-- Added By Priyanshu Singh For Billing Close Section Start -->
      <b-modal id="modal-lock-conf" ref="modal-lock-conf" title="Reason for Open Locked Assignment" centered
        no-close-on-esc no-close-on-backdrop hide-footer>
        <h3>Confirmation</h3>
        <form ref="form">
          <b-form-group label="Remark" label-for="name-input" invalid-feedback="Name is required">
            <b-form-textarea :formatter="capitalizeAll" rows="5" id="name-input" v-model="lockReason"
              required></b-form-textarea>
          </b-form-group>
        </form>
        <b-button @click="closeLockUnLockConfirm" variant="danger"> Cancel</b-button>
        <b-button v-if="lockReason" :disabled="lock_button ? true : false" variant="success" class="pull-right"
          @click="ConfLock">Send</b-button>
      </b-modal>
      <!-- Added By Priyanshu Singh For Billing Close Section End -->
      <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DocForm from "../../component/allModuleForm/docLibrary.vue";
import AddMessage from "../allModuleForm/addMessage.vue";
import AssignmentSummary from "../common/assignmentSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import AssignmentSplitMergeSummary from "../common/AssignmentSplitMergeSummary.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import MSDeleteRequest from "../common/MSDeleteRequest.vue";
import BRFCard from "../common/brfCard.vue";
export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    if (globalPermissionStatus("Sea Freight")) {
      this.checkUserLoginTime();
      this.$store.dispatch("setCurrentRoute", "/seaImport/viewSeaImportDetails");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewFFExportFCL("0", "0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      lock_allModuleId: "",
      lock_ffExportFclId: "",
      lock_ffExportFclSeries: "",
      lock_Type: "",
      lockReason: "",
      lock_button: false,
      is_locked: "",
      locked_counter: "",

      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      fields: [
        {
          key: "ffImportId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "ffImportSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "importerName",
          label: "Importer",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "ContainerNo",
          label: "Container No ",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "validBookingNo",
          label: "Booking No ",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "containerTypeName",
          label: "Container Type ",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "firstBLNumber",

          label: "BL Number",
          sortable: true,
          sortDirection: "ASC",
        },

        {
          key: "placeOfReceipt",
          label: "Location & Shipping Line",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "invoiceStatus",
          mainkey: "invoiceStatus",
          label: "Invoice Status",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "portOfDischarge",
          label: "",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      invoiceStatusList: [
        {
          inv: "1",
          int: "In-Progress",
        },
        {
          inv: "2",
          int: "Sent to Accounts",
        },
        {
          inv: "3",
          int: "Billing Not Started",
        },
        {
          inv: "",
          int: "All",
        },
      ],
      billingFilter: "",
      currentPage: 1,
      perPage: 10,
      totalRows: 1000000000000000,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      pending_preAlrt_Count: 0,
      pending_emptyR_Count: 0,
      pending_vesselEta_Count: 0,
      pending_icdArrive_Count: 0,
      pending_railOut_Count: 0,
      pending_Do_Count: 0,
      pending_VesselArrive_Count: 0,
      pending_icdOut_Count: 0,
      isLoading: true,
      debounce: null,
      seaImportData: [],

      dateStatusFilter: "60",
      dateStatusList: [
        {
          inv: "60",
          int: "2 Month",
        },
        {
          inv: "90",
          int: "3 Month",
        },
        {
          inv: "125",
          int: "4 Month",
        },
        {
          inv: "186",
          int: "6 Month",
        },
        {
          inv: "248",
          int: "8 Month",
        },
        {
          inv: "300",
          int: "10 Month",
        },
        {
          inv: "367",
          int: "1 Year",
        },
        {
          inv: "734",
          int: "2 Year",
        },

        {
          inv: "0",
          int: "Global ALL",
        },
      ],
    };
  },

  mounted() {
    // this.JqueryFun()
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },

  components: {
    // Loading,
    CustomLoader,
    DocForm,
    ModelListSelect,
    AddMessage,
    AssignmentSummary,
    ContainerSummary,
    JobWisePaymentsDetails,
    RejectInvTallyBillSummary,
    MSDeleteRequest,
    BRFCard,
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },

  methods: {
    checkUserLoginTime() {
      // Fetch the user's login time from your database or wherever you store it
      const userLoginTime = new Date(this.$sessionsStorage.get("ff_imp_job_pendency"));
      const currentTime = new Date();
      const compareTime = 3 * 60 * 60 * 1000;

      // Calculate the time difference in milliseconds
      const timeDifference = currentTime - userLoginTime;

      // If the time difference is greater than 3 hours (in milliseconds)
      // if (timeDifference > 3 * 60 * 60 * 1000) {
      if (timeDifference > compareTime) {
        // Redirect the user to another page using Vue Router
        this.$router.push("/ffImpPendency");
      }
    },
    ConfLock() {
      if (this.lockReason) {
        this.isLoading = true;
        let tit = "";
        if (this.is_locked == 1) {
          this.is_locked = "0";
          tit = "Un-Locked";
        } else if (this.is_locked == 1) {
          this.is_locked = "1";
          tit = "Locked";
        }
        this.lock_button = true;
        let payload = {
          allModuleId: this.lock_allModuleId,
          lockReason: this.lockReason,
          update_keyVal: this.lock_ffExportFclId,
          assigmnmentSeries: this.lock_ffExportFclSeries,
          Type: this.lock_Type,
          is_locked: this.is_locked,
          locked_counter: this.locked_counter,
          table_name: "ff_sea_import",
          update_key: "ffImportId",
          Title: tit,
          module_type: "FF Import",
        };
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/locknnlockStatus.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.find == 1) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.$refs["addPop"].open();
              this.viewFFExportFCL("0", "1", "1");
              this.lock_button = false;
              this.isLoading = false;
            }
            (this.lockReason = ""), this.$refs["modal-lock-conf"].hide();
          })
          .catch((error) => { });
      }
    },
    LockUnLock(items, type) {
      this.lock_allModuleId = items.allModuleId;
      this.lock_ffExportFclId = items.ffImportId;
      this.lock_ffExportFclSeries = items.ffImportSeries;
      this.lock_Type = type;
      this.is_locked = items.is_locked;
      this.locked_counter = items.locked_counter;
      console.log("Priyanshu Singh=>", items);
      // return false;
      this.$refs["modal-lock-conf"].show();
    },
    closeLockUnLockConfirm() {
      this.$refs["modal-lock-conf"].hide();
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.viewFFExportFCL("0", "0", "1", "1");

        // this.typing = null
        // this.message = event.target.value
      }, 1000);
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.ffImportSeries;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewFFExportFCL("0", CURRENT, "2", event);
    },
    filterClear() {
      this.filter = "";
      this.viewFFExportFCL("0", "0", "1", "1");
    },
    goToDoc(ID) {
      this.$router.push({
        path: "/freightForwarding/ffDocListPage/" + ID + "/Import",
      });
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewFFExportFCL("0", CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToMain() {
      this.$sessionsStorage.set("editffSeaImportId", "");
      this.$router.push({
        path: "/seaImport/ffseaImportFcl",
      });
    },
    JqueryFun() {
      return $(function () {
        return $("#conBooking").DataTable();
      });
    },

    viewExportSeaPage(item) {
      console.log("item => ", item.ffImportId);
      // alert(JSON.parse(item));
      let SEEN = item.seenExec;
      let SEA = item.ffImportId;
      this.$sessionsStorage.set("editffSeaImportId", SEA);
      if (SEEN != "1") {
        let paylod = {
          UpdateNotSeenToSeen: "yes",
          ffImportId: SEA,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/updateExecutionToSeenAllModules.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
            }
          })
          .catch((error) => { });
      }
      if (item.newContainerFlow == "1") {
        this.$router.push({
          path: "/seaImport/newFFseaImportFcl",
        });
      } else {
        this.$router.push({
          path: "/seaImport/ffseaImportFcl",
        });
      }
    },
    handleRefresh() {
      this.viewFFExportFCL("0", "0", "1", "1");
    },
    viewFFExportFCL(filterIdD, CURRENT, SEARCH, pageNumber) {
      this.seaImportData = [];
      this.isLoading = true;
      let payload = {
        view: "view",
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        billingFilter: this.billingFilter,
        dateStatusFilter: this.dateStatusFilter,
      };
      console.log("sasas", payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaImport/viewNormalSeaImportList_VP.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          console.log(data);
          if (status == 200 && data) {
            this.totalRows = data.totalData;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }
            if (data.SeaImportDetails.length > 0) {
              this.seaImportData = data.SeaImportDetails;
            }
            this.pending_preAlrt_Count = parseInt(data.pending_preAlrt_Count);
            this.pending_vesselEta_Count = parseInt(data.pending_vesselEta_Count);
            this.pending_emptyR_Count = parseInt(data.pending_emptyR_Count);
            this.pending_icdArrive_Count = parseInt(data.pending_icdArrive_Count);
            this.pending_railOut_Count = parseInt(data.pending_railOut_Count);
            this.pending_Do_Count = parseInt(data.pending_Do_Count);
            this.pending_icdOut_Count = parseInt(data.pending_icdOut_Count);
            this.pending_VesselArrive_Count = parseInt(data.pending_VesselArrive_Count);

            this.isLoading = false;
            this.JqueryFun();
          }
        })
        .catch((error) => { });
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// viewSeaImportDetails.vue?44e331a4